export default "__VITE_ASSET__10c64f35__"